import type { ReactNode } from 'react';

interface ButtonProps {
  variant: 'primary' | 'gradient' | 'inverted';
  href: string;
  children: ReactNode;
  fullWidth?: boolean;
}

const styles: Record<ButtonProps['variant'], React.CSSProperties> = {
  primary: {
    background: 'var(--brand-gradient)',
    color: '#ffffff',
  },
  gradient: {
    background: 'var(--brand-gradient)',
    color: '#ffffff',
  },
  inverted: {
    backgroundColor: '#ffffff',
    color: 'var(--brand-coral)',
  },
};

export function Button({ variant, href, children, fullWidth }: ButtonProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      style={{
        ...styles[variant],
        padding: '12px 24px',
        borderRadius: 'var(--radius)',
        fontWeight: 600,
        fontSize: '16px',
        textDecoration: 'none',
        display: fullWidth ? 'block' : 'inline-block',
        textAlign: 'center',
        width: fullWidth ? '100%' : undefined,
        transition: 'filter 150ms ease, background-color 150ms ease',
        fontFamily: 'var(--font-body)',
        border: 'none',
        cursor: 'pointer',
        lineHeight: '1.5',
      }}
      onMouseEnter={(e) => {
        const target = e.currentTarget;
        if (variant === 'primary' || variant === 'gradient') {
          target.style.filter = 'brightness(0.9)';
        } else {
          target.style.backgroundColor = '#f3f4f6';
        }
      }}
      onMouseLeave={(e) => {
        const target = e.currentTarget;
        if (variant === 'primary' || variant === 'gradient') {
          target.style.filter = 'none';
        } else {
          target.style.backgroundColor = '#ffffff';
        }
      }}
    >
      {children}
    </a>
  );
}
